import { SET_ITEM_SAVED_STATUS } from "../constants";

const resetItemSavedStatus = payload => dispatch =>
  dispatch({
    type: SET_ITEM_SAVED_STATUS,
    payload: { ...payload, saved: false }
  });

export default resetItemSavedStatus;
